<template>
  <j-modal
    :title="title"
    width="75%"
    :visible="visible"
    switchFullscreen
    @ok="handleOk"
    :body-style="{ height: '580px', overflow: 'hidden', overflowY: 'scroll' }"
    :okButtonProps="{ class: { 'jee-hidden': true } }"
    @cancel="handleCancel"
    :cancelText="$t('关闭')"
  >
    <a-spin :spinning="confirmLoading">
      <a-row :gutter="24">
        <a-col :md="5" :sm="24">
          <a-descriptions :title="$t('用户信息')" :column="1">
            <a-descriptions-item :label="$t('区域名称')"> {{ model.userAreaName }} </a-descriptions-item>
            <a-descriptions-item :label="$t('用户编号')"> {{ model.userId }} </a-descriptions-item>
            <a-descriptions-item :label="$t('用户名称')"> {{ model.userName }} </a-descriptions-item>
            <a-descriptions-item :label="$t('用水性质')"> {{ model.wtName }} </a-descriptions-item>
            <a-descriptions-item :label="$t('用户类型')"> {{ model.userTypeName }} </a-descriptions-item>
            <a-descriptions-item :label="$t('身份类型')">{{ model.userIdType == 1 ? $t('自然人') : $t('企业') }}</a-descriptions-item>
            <a-descriptions-item :label="$t('建档时间')">{{ model.createTime }}</a-descriptions-item>
          </a-descriptions>
          <a-descriptions :title="$t('水表信息')" :column="1">
            <a-descriptions-item :label="$t('表编号')"> {{ model.meterId }} </a-descriptions-item>
            <a-descriptions-item :label="$t('表类型')"> {{ model.mtName }} </a-descriptions-item>
            <a-descriptions-item :label="$t('表口径')"> {{ 'DN' + model.mtCaliber }} </a-descriptions-item>
            <a-descriptions-item :label="$t('表厂家')"> {{ model.meterTypeName }} </a-descriptions-item>
            <a-descriptions-item :label="$t('出厂时间')">{{ model.mtFactoryTime }}</a-descriptions-item>
            <a-descriptions-item :label="$t('安装地址')">{{ model.userMeterAddr }}</a-descriptions-item>
          </a-descriptions>
          <a-descriptions :title="$t('地理信息')" :column="1"></a-descriptions>
          <!-- 地图 -->
          <div style="width: 100%; height: 200px" id="amapDiv">
            <baidu-map
              :center="center"
              :zoom="zoom"
              :style="{ height: '100%' }"
              :scroll-wheel-zoom="scrollZoom"
              NavigationControlType="BMAP_NAVIGATION_CONTROL_LARGE"
              @ready="mapReady"
            >
            </baidu-map>
          </div>
        </a-col>
        <a-col :md="19" :sm="24">
          <!-- <a-card :bordered="false"> -->
          <!-- 统计 -->
          <div class="flex flex-center" style="margin-bottom: 15px">
            <div class="flex-item" style="height: 80px" v-for="item in totalList" :key="item.key">
              <div
                class="flex-center"
                style="height: 100%; background: #e6f7ff; border: 1px solid #91d5ff; justify-content: space-around"
              >
                <div>
                  <div class="flex-center" style="color: #999999">{{ item.title }}</div>
                  <div class="flex-center">
                    <span class="" style="font-size: 24px; font-weight: 500">{{ item.num }}</span>
                    <span class="unit" style="color: #999999">{{ item.unit }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 查询区域 -->
          <div class="table-page-search-wrapper">
            <a-form layout="inline" @keyup.enter.native="searchQuery">
              <a-row :gutter="24">
                <a-col :xl="8" :lg="7" :md="8" :sm="24">
                  <a-form-item :label="$t('上报时间')">
                    <a-range-picker
                      v-model="date"
                      format="YYYY-MM-DD"
                      value-format="YYYY-MM-DD"
                      :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                      @change="onDateRangeChange"
                    />
                  </a-form-item>
                </a-col>
                <a-col :xl="6" :lg="7" :md="8" :sm="24">
                  <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
                    <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                    <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
                  </span>
                </a-col>
              </a-row>
            </a-form>
          </div>
          <!-- table区域-begin -->
          <div class="table-fixed">
            <div class="radio_button_group">
              <a-radio-group
                button-style="solid"
                v-model="radioValue"
                style="margin-bottom: 16px"
                @change="changeRadio"
              >
                <a-radio-button value="1"><a-icon type="unordered-list" /></a-radio-button>
                <a-radio-button value="2"><a-icon type="bar-chart" /></a-radio-button>
              </a-radio-group>
            </div>
            <a-table
              ref="table"
              size="middle"
              :scroll="{ x: true }"
              bordered
              rowKey="id"
              :columns="columns"
              :dataSource="dataSource"
              :pagination="ipagination"
              :loading="loading"
              @change="handleTableChange"
              v-if="radioValue == 1"
            >
              <template slot="userStateSlot" slot-scope="text">
                <a-button :class="text == 1 ? 'normalbg-status' : text == 0 ? 'unactivebg-status' : ''">
                  {{ text == 1 ? $t('已激活') : text == 0 ? $t('未激活') : '' }}
                </a-button>
              </template>
              <span slot="action" slot-scope="text, record" class="action">
                <a @click="handleDetail(record)">{{ $t('详情') }}</a>
              </span>
            </a-table>
            <div style="height: 100%" v-if="radioValue == 2">
              <a-card size="small" :title="$t('历史用水量曲线')">
                <!-- <div slot="extra">
                  <a-radio-group button-style="solid" size="small" v-model="cycleValue" @change="changeCycle">
                    <a-radio-button value="1">日</a-radio-button>
                    <a-radio-button value="2">周</a-radio-button>
                    <a-radio-button value="3">月</a-radio-button>
                  </a-radio-group>
                </div> -->
                <div id="chart" style="height: 300px; width: 100%"></div>
              </a-card>
            </div>
          </div>
          <!-- </a-card> -->
        </a-col>
      </a-row>
    </a-spin>
  </j-modal>
</template>
        
<script>
import JSelectUserByDep from '@/components/jeecgbiz/JSelectUserByDep'
import JDictSelectTag from '@/components/dict/JDictSelectTag.vue'
import { httpAction, getAction, postAction } from '@/api/manage'
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import moment from 'moment'
import {Mn100FkStatusObj} from '@/utils/constants/protocolConstant'
import *as echarts from 'echarts'
export default {
  name: 'RepairModal',
  mixins: [JeecgListMixin],
  components: { JDictSelectTag, JSelectUserByDep },
  data() {
    return {
      width: 800,
      visible: false,
      disableSubmit: false,
      model: {},
      confirmLoading: false,
      url: {
        list: '/jeecg-charge/importantUser/listUserWaterUsedInfo',
        listUserWaterUsedInfo: "/jeecg-charge/importantUser/listUserWaterUsedInfo"
      },
      radioValue: '1',
      // 统计项数值（totalList 改为 computed 后由此响应式承接）
      statData: {
        balance: '0',
        calNum: '0',
        currentUsage: '0',
        valveStatus: '-',
        lastUsage: '0',
        rate: '0',
      },
      date: [],
      dataSource: [],
      BMap: '',
      map: '',
      center: { lng: 118.904, lat: 31.915 }, //中心坐标
      centerPoint: { lng: 118.904, lat: 31.915 },
      zoom: 10, //初始缩放比
      scrollZoom: true, //允许鼠标滚轮缩放
      mapInfo: {},
      position: {},
      show: false,
      iconList: {
        0: require('@/assets/inspectionImage/circle_red.png'),
        1: require('@/assets/inspectionImage/circle_green.png'),
        2: require('@/assets/inspectionImage/circle_gray.png'),
      },
      Mn100FkStatusObj
    }
  },
  computed: {
    // i18n：modal 标题
    title() {
      return this.$t('用户分析')
    },
    // i18n：校验规则使用 computed 以响应语言切换
    validatorRules() {
      return {
        meterId: [{ required: true, message: this.$t('请输入表编号'), trigger: 'change' }],
        repairTime: [{ required: true, message: this.$t('请选择维修时间'), trigger: 'change' }],
        repairType: [{ required: true, message: this.$t('请选择维修类型'), trigger: 'change' }],
        repairBy: [{ required: true, message: this.$t('请选择操作员'), trigger: 'change' }],
      }
    },
    // i18n：统计项标题使用 computed 以响应语言切换
    totalList() {
      return [
        { key: 1, title: this.$t('当前余额'), num: this.statData.balance, unit: this.$t('元') },
        { key: 2, title: this.$t('累计流量'), num: this.statData.calNum, unit: 'm³' },
        { key: 3, title: this.$t('当前用水量'), num: this.statData.currentUsage, unit: 'm³' },
        { key: 4, title: this.$t('阀门状态'), num: this.statData.valveStatus, unit: '' },
        // { key: 5, title: this.$t('表具状态'), num: '', unit: '' },
        { key: 6, title: this.$t('昨日用水量'), num: this.statData.lastUsage, unit: 'm³' },
        { key: 7, title: this.$t('变化率'), num: this.statData.rate, unit: '%' },
      ]
    },
    // i18n：表头使用 computed 以响应语言切换
    columns() {
      return [
        {
          title: this.$t('日期'),
          dataIndex: 'date',
          align: 'center',
          width: 150,
        },
        {
          title: this.$t('日用量'),
          dataIndex: 'value',
          align: 'center',
          width: 150,
        },
      ]
    },
  },
  methods: {
    init(record) {
      this.model = Object.assign({}, record)
      this.visible = true
      this.radioValue = '1'
      this.date = [];
      this.dataSource = [];
      if(this.date.length>0) this.getlistUserWaterUsedInfo();
      else this.$message.warning(this.$t('请选择分析时间！'))
      this.center = { lng: this.model.userMeterLng, lat: this.model.userMeterLat }
      this.mapReady({ BMap: this.BMap, map: this.map })
    },
    getlistUserWaterUsedInfo(){
      let params = {
        meterId:this.model.meterId,
        beginDate: this.date[0],
        endDate: this.date[1]
      }
      postAction(this.url.listUserWaterUsedInfo,params).then(res=>{
        if(res.success){
          this.dataSource = res.result.usedList;
          this.statData.balance = res.result.userAccountNum||0;
          this.statData.calNum = res.result.userCalNum||0;
          this.statData.currentUsage = res.result.currentFlowSum||0;
          this.statData.valveStatus = this.$t(this.Mn100FkStatusObj[res.result.meterValveStatus]);
          // this.statData.meterStatus = res.result.meterValveStatus;
          this.statData.lastUsage = res.result.lastFlowSum||0;
          this.statData.rate = res.result.rate||0;
          this.setchart(res.result);
        }
      })
    },
    setchart(data){
      let xData = data.rateList.map(item=>item.date);
      let yData = data.rateList.map(item=>item.value);
      let chart = echarts.init(document.getElementById('chart'));
      chart.setOption({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            animation: false
          }
        },
        xAxis: {
          type: 'category',
          data: xData,
        },
        yAxis: {
          type: 'value',
          name: 'm³',
        },
        dataZoom: [
          {
            type: 'inside',
            start: 0,
            end: 100,
          },
          {
            start: 0,
            end: 100,
          },
        ],
        series: [
          {
            data: yData,
            type: 'line',
            markPoint: {
                data: [
                    {type: 'max', name: this.$t('最大值')},
                    {type: 'min', name: this.$t('最小值')}
                ]
            },
            markLine: {
              data: [
                { type: 'average', name: this.$t('平均值'),value: data.rateAvg },
                { type: 'min', name: this.$t('最小值'),value: data.rateMin },
                { type: 'max', name: this.$t('最大值'),value: data.rateMax }
              ]
            }
          }
        ]
      })
      window.addEventListener('resize', () => {
        chart.resize()
      })
    },
    searchQuery(){
      this.getlistUserWaterUsedInfo();
    },
    searchReset(){
      this.date = []
      this.getlistUserWaterUsedInfo();
    },
    close() {
      this.$emit('close')
      this.visible = false
    },
    handleOk() {},
    handleCancel() {
      this.close()
    },
    changeRadio(e) {
      this.getlistUserWaterUsedInfo();
    },
    //地图默认方法
    mapReady({ BMap, map }) {
      let that = this
      this.BMap = BMap
      this.map = map
      map.enableDragging()
      map.enableScrollWheelZoom()
      map.enableDoubleClickZoom()
      map.enablePinchToZoom()
      map.enableKeyboard()
      map.clearOverlays()
      if (this.model.userMeterLng && this.model.userMeterLat) {
        var point = {
          lng: this.model.userMeterLng,
          lat: this.model.userMeterLat,
        }
        this.center = point
        let myIcon = new BMap.Icon(
          //也可以设置不同坐标点上的icon，需要自己定义
          require('@/assets/inspectionImage/circle_green.png'),
          new BMap.Size(40, 40), //图标可视区域大小
          { anchor: new BMap.Size(18, 18) } //图标定位点相对于图标左上角的偏移量
        )
        myIcon.setImageSize(new BMap.Size(30, 30)) // 设置icon大小
        var marker = new BMap.Marker(point, { icon: myIcon }) // 创建标注
        map.addOverlay(marker) // 将标注添加到地图中
        //icon标识内容位置
        let label = new BMap.Label(this.model.id, { offset: new BMap.Size(3, 0) })
        // 文本标识样式
        label.setStyle({
          // fontWeight: 600,
          fontSize: '14px',
          color: 'black',
          backgroundColor: '#fff',
          border: '1px solid #000',
          display: 'none',
        })
        marker.setLabel(label) // 为icon添加文本标识
      }
    },
  },
}
</script>
<style scoped>
.table-fixed /deep/ .ant-table-bordered .ant-table-fixed-left table {
  border-right: 1px solid #e8e8e8;
}

.table-fixed /deep/ .resize-table-th {
  position: relative;
}
.table-fixed /deep/ .table-draggable-handle {
  border: 1px solid red;
  height: 100% !important;
  left: auto !important;
  right: -5px;
  cursor: col-resize;
  touch-action: none;
  border: none;
  position: absolute;
  transform: none !important;
  bottom: 0;
}
::v-deep .ant-descriptions-title {
  margin-bottom: 5px;
}
::v-deep .ant-descriptions-row > th,
::v-deep .ant-descriptions-row > td {
  padding-bottom: 5px;
}
::v-deep .ant-descriptions-item > span {
  display: inline;
}
.radio_button_group {
  position: absolute;
  right: 14px;
  top: 95px;
}
</style>